import { __decorate } from "tslib";
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { Chart, ArcElement, LineElement, BarElement, PointElement, BarController, BubbleController, DoughnutController, LineController, PieController, PolarAreaController, RadarController, ScatterController, CategoryScale, LinearScale, LogarithmicScale, RadialLinearScale, TimeScale, TimeSeriesScale, Decimation, Filler, Legend, Title, Tooltip, SubTitle } from 'chart.js';
import { chartDefaultOptions } from "@/utils/chartDefaultOptions";
import DataLabels from "chartjs-plugin-datalabels";
import { HierarchicalScale } from "chartjs-plugin-hierarchical";
Chart.register(ArcElement, LineElement, BarElement, PointElement, BarController, BubbleController, DoughnutController, LineController, PieController, PolarAreaController, RadarController, ScatterController, CategoryScale, LinearScale, LogarithmicScale, RadialLinearScale, TimeScale, TimeSeriesScale, Decimation, Filler, Legend, Title, Tooltip, SubTitle);
let PieChart = class PieChart extends Vue {
    id;
    data;
    options;
    canvas;
    chart = null;
    mounted() {
        this.renderChart();
    }
    renderChart() {
        this.chart = new Chart(this.canvas.getContext('2d'), {
            type: 'pie',
            data: this.data,
            options: this.options,
            plugins: [
                DataLabels,
                HierarchicalScale,
            ],
        });
    }
    beforeDestroy() {
        if (this.chart !== null) {
            this.chart.destroy();
        }
    }
};
__decorate([
    Prop({ required: true })
], PieChart.prototype, "id", void 0);
__decorate([
    Prop({ required: true })
], PieChart.prototype, "data", void 0);
__decorate([
    Prop({ default: () => chartDefaultOptions })
], PieChart.prototype, "options", void 0);
__decorate([
    Ref('canvas')
], PieChart.prototype, "canvas", void 0);
PieChart = __decorate([
    Component
], PieChart);
export default PieChart;
